module.exports = __webpack_public_path__ + "static/media/ligntbulb-icon-large.28763524.svg";